export const GridData = [
    {
        ProductID: 1,
        Title: 'Data Entry Time (Bunching If Over 60 Forms)-Mean',
        Description:
            // eslint-disable-next-line max-len
            'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo. Nullam dictum felis eu pede mollis pretium. Integer tincidunt. Cras dapibus. Vivamus elementum',
        datasetDate: '2025-08-26T00:00:00Z',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'RED',
            score: '50',
        },
        riskScore: {
            prevScore: 1,
            curScore: 2,
            direction: 'Increasing',
        },
    },
    {
        ProductID: 2,
        Title: 'Serious Adverse Event Rate (From Screening)',
        Description:
            // eslint-disable-next-line max-len
            'porttitor eu, consequat vitae, eleifend ac, enim. Aliquam lorem ante, dapibus in, viverra quis, feugiat a, tellus. Phasellus viverra nulla ut metus varius laoreet. Quisque rutrum. Aenean imperdiet. Etiam ultricies nisi vel augue. Curabitur ullamcorper ultricies nisi. Nam eget dui. Etiam rhoncus. Maecenas tempus, tellus eget condimentum rhoncus, sem quam semper libero, sit amet adipiscing sem neque sed ipsum. Nam quam nunc, blandit vel, luctus pulvinar, hendrerit id, lorem. Maecenas nec odio et ante tincidunt tempus. Donec vitae sapien ut libero venenatis faucibus. Nullam quis ante. Etiam sit amet orci eget eros faucibus tincidunt. Duis leo. Sed fringilla mauris sit amet nibh. Donec sodales sagittis magna. Sed consequat, leo eget bibendum sodales, augue velit cursus nunc,',
        datasetDate: '2025-08-24T00:00:00Z',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'Green',
            score: '150',
        },
        riskScore: {
            prevScore: 100,
            curScore: 50,
            direction: 'Decreasing',
        },
    },
    {
        ProductID: 3,
        Title: 'Tx Discontinuation Rate',
        Description:
            // eslint-disable-next-line max-len
            'Sed consequat, leo eget bibendum sodales, augue velit cursus nunc, quis gravida magna mi a libero. Fusce vulputate eleifend sapien. Vestibulum purus quam, scelerisque ut, mollis sed, nonummy id, metus. Nullam accumsan lorem in dui. Cras ultricies mi eu turpis hendrerit fringilla. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; In ac dui quis mi consectetuer lacinia. Nam pretium turpis et arcu. Duis arcu tortor, suscipit eget, imperdiet nec, imperdiet iaculis, ipsum.',
        datasetDate: '2025-08-24T00:00:00Z',
        reviewedStatus: 'Unreviewed',
        isActive: false,
        score: {
            colour: 'None',
            score: '',
        },
        riskScore: {
            prevScore: 13,
            curScore: 200,
            direction: 'Increasing',
        },
    },
    {
        ProductID: 4,
        Title: 'System Query Rate (Bunching If Over 60 Forms)',
        Description:
            // eslint-disable-next-line max-len
            'Maecenas tempus, tellus eget condimentum rhoncus, sem quam semper libero, sit amet adipiscing sem neque sed ipsum. Nam quam nunc, blandit vel, luctus pulvinar, hendrerit id, lorem. Maecenas nec odio et ante tincidunt tempus. Donec vitae sapien ut libero venenatis faucibus. Nullam quis ante. Etiam sit amet orci eget eros faucibus tincidunt. Duis leo. Sed fringilla mauris sit amet nibh. Donec sodales sagittis magna.',
        datasetDate: '2025-08-23T00:00:00Z',
        reviewedStatus: 'Reviewed',
        isActive: true,
        score: {
            colour: 'Amber',
            score: '150',
        },
        riskScore: {
            prevScore: 40,
            curScore: 40,
            direction: 'No Change',
        },
    },
];
